import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Header } from "@/components/Header";
import { toast } from "sonner";

const AdminLoginPage = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("impact_admin_token", data.access_token);
      navigate("/admin/dashboard");
    } catch {
      toast.error(t("admin.invalid"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen" data-testid="admin-login-page">
      <Header />
      <main className="max-w-md mx-auto px-6 py-16 md:py-24">
        <div className="impact-card p-10">
          <div className="w-11 h-11 rounded-lg bg-[color:var(--impact-ink)] text-white grid place-items-center mb-6">
            <Lock size={18} />
          </div>
          <h1 className="font-display font-bold text-3xl mb-2">{t("admin.loginTitle")}</h1>
          <p className="text-[color:var(--impact-ink-2)] mb-8">{t("admin.loginSubtitle")}</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <div className="eyebrow mb-2">{t("admin.email")}</div>
              <input
                data-testid="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-[color:var(--impact-border)] focus:outline-none focus:ring-2 focus:ring-[color:var(--impact-ink)]/20"
              />
            </div>
            <div>
              <div className="eyebrow mb-2">{t("admin.password")}</div>
              <input
                data-testid="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-[color:var(--impact-border)] focus:outline-none focus:ring-2 focus:ring-[color:var(--impact-ink)]/20"
              />
            </div>
            <button data-testid="admin-signin-btn" disabled={loading} className="btn-primary w-full justify-center mt-2">
              {loading ? "…" : t("admin.signIn")}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AdminLoginPage;
